var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ReleaseService } from './release.service';
import { Injectable } from '@angular/core';
var FlagService = (function () {
    function FlagService(release) {
        this.release = release;
    }
    FlagService.prototype.isAuth0LoginActive = function () { return this.release.getFlag('Auth0Login'); };
    FlagService.prototype.isAlgoleaSearchActive = function () { return this.release.getFlag('AlgoliaSearch'); };
    FlagService.prototype.isFilePOActive = function () { return this.release.getFlag('file_po'); };
    FlagService.prototype.isFileItemActive = function () { return this.release.getFlag('file_item'); };
    FlagService.prototype.isFileActive = function () { return this.release.getFlag('file_po') || this.release.getFlag('file_item'); };
    FlagService.prototype.isPromoActive = function () { return this.release.getFlag('promo'); };
    FlagService.prototype.isItemBrandActive = function () { return this.release.getFlag('item_brand'); };
    FlagService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [ReleaseService])
    ], FlagService);
    return FlagService;
}());
export { FlagService };
//# sourceMappingURL=flag.service.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/features/flag.service.js
// module id = 40
// module chunks = 0